import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { TypographyTextColorVariant } from 'apps/sigma2-ui/src/components/ui/Typography';
import { FilterItemWrapper } from 'apps/sigma2-ui/src/filters-v2/components/FilterItemWrapper';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';

export interface FilterSingleItemProps {
  /**
   * Callback when item is clicked
   * @param newChecked
   */
  onClick: () => void;

  /**
   * The current selected state
   */
  selected: boolean;

  /**
   * The label for the selectable item
   */
  translatedContent: TranslatedContent;

  /**
   * The right side icon (optional)
   */
  icon: React.FC<SvgProps> | null;

  color: TypographyTextColorVariant | null;

  /**
   * The item value (should be unique) for tracking purposes.
   */
  itemValue: string;
}

export const FilterSingleItem = ({
  onClick,
  selected,
  translatedContent,
  icon,
  color,
  itemValue,
}: FilterSingleItemProps) => {
  return (
    <TouchTarget
      content={({ hovered }) => (
        <FilterItemWrapper highlight={hovered || selected}>
          <Spacing
            direction={'horizontal'}
            size={'sm'}
            className={'items-center cursor-pointer pl-2'}
          >
            <S2Typography
              variant={'body-7'}
              translatedContent={translatedContent}
              textColorVariant={color ?? 'gray-900'}
              truncate={true}
              flex={true}
            />
            {icon !== null &&
              icon({
                svg: {
                  className: `w-4 h-4 text-${color ?? 'gray-400'}`,
                },
                wantsCurrentColor: true,
              })}
          </Spacing>
        </FilterItemWrapper>
      )}
      behavior={{
        type: 'onClick',
        onClick: () => {
          onClick();
        },
      }}
      className={'filter-single-item'}
      dataExtras={{
        itemValue,
        selected: selected ? '1' : '0',
      }}
    />
  );
};
